function StarIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.62875 13.546L8.77875 11.646L11.9288 13.571L11.1038 9.971L13.8788 7.571L10.2288 7.246L8.77875 3.846L7.32875 7.221L3.67875 7.546L6.45375 9.971L5.62875 13.546ZM3.35375 16.6825L4.7865 10.5133L0 6.36525L6.31525 5.81725L8.77875 0L11.2422 5.81725L17.5575 6.36525L12.771 10.5133L14.2038 16.6825L8.77875 13.4095L3.35375 16.6825Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default StarIcon;
